module.exports = __webpack_public_path__ + "static/img/PS-NA4.bba6082.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productConter/params/PS-NA4.png
// module id = gHzI
// module chunks = 1